export default __webpack_public_path__ + "static/image-1-3624c188fc25eabbea995d7af3d42f45.png";